const colour = {
  black: '#000000',
  black60: '#999999',
  black40: '#666666',
  black25: '#bfbfbf',

  charcoal: '#333333',
  charcoal60: '#858585',
  charcoal40: '#adadad',
  charcoal25: '#cccccc',

  darkgray: '#8f8f8f',
  darkgray60: '#bcbcbc',
  darkgray40: '#d2d2d2',
  darkgray25: '#e3e3e3',

  mediumgray: '#cecece',
  mediumgray60: '#e2e2e2',
  mediumgray40: '#ebebeb',
  mediumgray25: '#f3f3f3',

  lightgray: '#eaeaea',
  lightgray60: '#f2f2f2',
  lightgray40: '#f7f7f7',
  lightgray25: '#fafafa',

  offwhite: '#fafbfc',
  offwhite60: '#fcfdfd',
  offwhite40: '#fdfdfc',
  offwhite25: '#fefefe',

  red: '#D0021B',
  red60: '#e36776',
  red40: '#ec9aa4',
  red25: '#f3c0c6',

  green: '#00A44C',
  green60: '#66c894',
  green40: '#99dbb7',
  green25: '#bfe8d2',

  amber: '#F6A623',
  amber60: '#FFC166',
  amber40: '#FFD699',
  amber25: '#FFE5BF',

  white: '#ffffff'
};

export default colour;
